export const DEFAULT_WORKSPACE_NAME = 'My personal workspace'
export const DEFAULT_PROJECT_NAME = 'My personal project'
